import { render, staticRenderFns } from "./OutcomeChips.vue?vue&type=template&id=e8f53d0a"
import script from "./OutcomeChips.vue?vue&type=script&lang=js"
export * from "./OutcomeChips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports